import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoaderService {
    public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private ngZone: NgZone) {}

    /**
     * Show or hide the global loader.
     * Updates happen immediately and are guaranteed to run in Angular zone
     * to trigger change detection properly.
     */
    display(value: boolean) {
        // Ensure the update runs in Angular zone to trigger change detection
        this.ngZone.run(() => {
            this.status.next(value);
        });
    }
}
